
import { memo, useCallback } from "react";
import { CiFaceFrown } from "react-icons/ci";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import ReactModal from "react-modal";
import { color_black, color_red_default, color_transparent, color_white } from "../../constants/colors";
import { MODAL_Z_INDEX_BASE } from "../../constants/layers";
import smilingFaceIcon from "../../images/smiling_face_success_payment.svg";
import sweatyFaceIcon from "../../images/sweaty_face_payment_failed.svg";
import { useWindowDimensions } from "../../utils";
import { Button } from "../controls/Button/Button";
import { OnestMedium, OnestNormalDefault, OnestSemiBoldBig } from "../styled/TextComponents";
import { useI18n } from "../../i18n/I18nProvider";

const ModalSimple = memo(({ type, h2, isOpen, onClose, buttonText, p, zIndex = MODAL_Z_INDEX_BASE }) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();

    const handleClose = useCallback(() => {
        onClose("");
    }, [onClose]);

    const isPaymentFailed = h2 === "Оплата не прошла" || h2 === t("Оплата не прошла");
    const isPaymentSuccess = h2 === "Оплата прошла успешно!" || h2 === t("Оплата прошла успешно!");
    const isPaymentAlert = type === "alert" && isPaymentFailed;
    const isInfoAlert = type === "alert" && !isPaymentFailed;
    const alertUsesBodyOnly = isInfoAlert && !p;

    const modalWidth = isInfoAlert
        ? (screenWidth > 500 ? 418 : Math.max(screenWidth - 24, 280))
        : (screenWidth > 550 ? 400 : screenWidth - 80);

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={handleClose}
            style={{
                content: {
                    backgroundColor: color_white,
                    borderRadius: isInfoAlert ? "20px" : "16px",
                    width: modalWidth,
                    height: "min-content",
                    margin: isInfoAlert ? undefined : "auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: isInfoAlert ? "30px" : "24px 24px 26px",
                    boxSizing: "border-box",
                    ...(isInfoAlert
                        ? {
                            top: "50%",
                            left: "50%",
                            right: "auto",
                            bottom: "auto",
                            transform: "translate(-50%, -50%)",
                        }
                        : {
                            inset: screenWidth > 460 ? "40px" : `calc(50vw - ${(screenWidth - 80) / 2}px)`,
                        }),
                    zIndex: zIndex + 1,
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "scroll",
                    zIndex,
                },
            }}
        >
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: isInfoAlert ? "stretch" : "center",
                gap: isInfoAlert ? "24px" : "12px",
                width: "100%",
            }}>
                {type === "success" && isPaymentSuccess &&
                    <img src={smilingFaceIcon} alt="smiling face" style={{ width: 33, height: 33, alignSelf: "center" }} />
                }
                {type === "success" && !isPaymentSuccess &&
                    <IoMdCheckmarkCircleOutline size={28} style={{ alignSelf: "center" }} />
                }
                {isPaymentAlert &&
                    <img src={sweatyFaceIcon} alt="sweaty face" style={{ width: 28, height: 28, alignSelf: "center" }} />
                }
                {type === "error" &&
                    <CiFaceFrown size={28} style={{ alignSelf: "center" }} />
                }

                {!alertUsesBodyOnly && h2 && (
                    isPaymentFailed ? (
                        <OnestMedium style={{ fontSize: "28px", textAlign: "center", color: color_black, marginTop: 8 }}>{t(h2)}</OnestMedium>
                    ) : (
                        <OnestSemiBoldBig style={{
                            fontSize: type !== "alert" ? "24px" : "14px",
                            textAlign: "center",
                            color: color_black,
                            marginTop: 8,
                            alignSelf: "center",
                        }}>
                            {t(h2)}
                        </OnestSemiBoldBig>
                    )
                )}

                {(p || alertUsesBodyOnly) && (
                    isPaymentFailed ? (
                        <OnestNormalDefault style={{ textAlign: "center", padding: "0 40px", maxWidth: "350px", alignSelf: "center" }}>
                            {t(p)}
                        </OnestNormalDefault>
                    ) : (
                        <OnestNormalDefault style={{
                            fontSize: "16px",
                            lineHeight: "140%",
                            textAlign: "center",
                            color: color_black,
                            margin: 0,
                            alignSelf: "center",
                            maxWidth: isInfoAlert ? "100%" : "350px",
                            padding: isInfoAlert ? 0 : "0 40px",
                        }}>
                            {t(p || h2)}
                        </OnestNormalDefault>
                    )
                )}

                <Button
                    outline={false}
                    type="submit"
                    width={isInfoAlert ? "100%" : 224}
                    height={isInfoAlert ? 60 : 40}
                    backgroundColor={color_red_default}
                    color={color_white}
                    borderColor={color_transparent}
                    fontSize={16}
                    onClick={handleClose}
                    style={{
                        color: color_white,
                        border: "none",
                        marginTop: isInfoAlert ? 0 : "30px",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontWeight: (isPaymentFailed || isPaymentSuccess) ? 400 : 500,
                        fontFamily: "Onest",
                        alignSelf: isInfoAlert ? "stretch" : "center",
                    }}
                >
                    {buttonText ? t(buttonText) : t("Закрыть")}
                </Button>
            </div>
        </ReactModal>
    )
})

export default ModalSimple
